import Router from 'next/router';
import VendorAPIManager from '../repository/vendor';
import { qlubSessionStorage } from '../service/storage/sessionStorage';
import { parseJSON } from '../utility/k_json';

export const getStoredEvents = () => {
    return parseJSON(qlubSessionStorage.get('qlub_stored_events'));
};

export const getStoredEventObjects = () => {
    return parseJSON(qlubSessionStorage.get('qlub_stored_event_objects'));
};

export const setStoredEvents = (event: string) => {
    const currentStore = getStoredEvents() || [];
    currentStore.push(event);
    qlubSessionStorage.set('qlub_stored_events', JSON.stringify(currentStore));
};

export const setStoredEventObjects = (eventObj: string) => {
    const eventObjectStore = getStoredEventObjects() || [];
    eventObjectStore.push(eventObj);
    qlubSessionStorage.set('qlub_stored_event_objects', JSON.stringify(eventObjectStore));
};

export const removeSpecificEventsFromEventStore = (eventNames: string[]) => {
    const existingEvents: string[] | null = getStoredEvents();

    if (existingEvents) {
        const filteredEvents = existingEvents.filter((exitingEventName) => !eventNames.includes(exitingEventName));
        qlubSessionStorage.set('qlub_stored_events', JSON.stringify(filteredEvents));
    }
};

export const hasAlreadyTriggered = (currentEvent: string, eventObj?: string, thoroughCheck?: boolean) => {
    if (thoroughCheck && eventObj) {
        const eventObjStore = getStoredEventObjects() || [];

        if (!eventObjStore?.find((ce: string) => ce === eventObj)) {
            setStoredEventObjects(eventObj);
            return false;
        }

        return true;
    }

    const currentStore = getStoredEvents() || [];

    if (!currentStore?.find((ce: string) => ce === currentEvent)) {
        setStoredEvents(currentEvent);
        return false;
    }

    return true;
};

export const isNewPaymentModule = () => {
    const vendor = VendorAPIManager.getInstance().getVendorCache(Router.query as any);
    return Boolean(vendor?.config?.enableNewPaymentModule);
};
